import { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import { FormHandles } from "models/propTypes/genericFormProps";
import { CustomerFormTypes } from "models/formTypes";
import { CustomerImportFormContainerProps } from "models/propTypes/customerPropTypes";
import { TranslationKeys } from "translations";
//#endregion
//#region components
import CustomerImportForm from "./importForm";
import useCustomerImportSubmit from "../import/useCustomerImportSubmit";
//#endregion
import * as Yup from "yup";
import { LocalizationHelperInstance } from "utils/helpers";

const CustomerImportFormContainer: ForwardRefRenderFunction<FormHandles, CustomerImportFormContainerProps> = (
  props,
  ref
) => {
  const handleSubmit = useCustomerImportSubmit(props.onFormSubmitSuccess);

  const validationSchema = Yup.object<CustomerFormTypes.CustomerImport>({
    csvUpload: Yup.array()
      .max(1, LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Validations.Max, "", { max: "1" }))
      .min(1, TranslationKeys.Validations.Required)
      .required(TranslationKeys.Validations.Required),
    customerNameColumn: Yup.string().required(TranslationKeys.Validations.Required),
    orgNrColumn: Yup.string(),
    emailAddressColumn: Yup.string(),
    phoneNumberColumn: Yup.string(),
    billingStreetColumn: Yup.string(),
    billingStreet2Column: Yup.string(),
    billingZipCodeColumn: Yup.string(),
    billingCityColumn: Yup.string(),
    billingCountryCodeColumn: Yup.string(),
    deliveryStreetColumn: Yup.string(),
    deliveryStreet2Column: Yup.string(),
    deliveryZipCodeColumn: Yup.string(),
    deliveryCityColumn: Yup.string(),
    deliveryCountryCodeColumn: Yup.string(),
    vatNumberColumn: Yup.string(),
    glnNumberColumn: Yup.string(),
    includeVatNumberOnInvoiceColumn: Yup.string(),
    customerStandardPaymentTermsColumn: Yup.string(),
    showCurrencyCodeColumn: Yup.string(),
    languageColumn: Yup.string(),
    referencePersons: Yup.array().of(
      Yup.object<CustomerFormTypes.ReferencePersonImport>({
        nameColumn: Yup.string(),
        mailColumn: Yup.string(),
        phoneColumn: Yup.string(),
        identifierColumn: Yup.string(),
        isDefaultColumn: Yup.string(),
      })
    ),
    propertyDesignationColumn: Yup.string(),
    tenantsOwnerAssociationOrgNumberColumn: Yup.string(),
    apartmentNumberColumn: Yup.string(),
  });

  return (
    <CustomerImportForm
      ref={ref}
      validationSchema={validationSchema}
      defaultValues={{}}
      handleSubmit={handleSubmit}
      onFormValidationChange={props.onFormValidationChange}
      onFormSubmitSuccess={props.onFormSubmitSuccess}
    />
  );
};

export default forwardRef(CustomerImportFormContainer);
